if (!window.sheetDialogs) {
  window.sheetDialogs = true;

  const openers = new WeakMap();

  window.openSheet = (dialog, opener) => {
    if (!dialog || dialog.open) return;
    openers.set(dialog, opener || document.activeElement);
    dialog.opener = opener || document.activeElement;
    dialog.showModal();
    opener?.setAttribute('aria-expanded', 'true');
  };

  document.addEventListener(
    'close',
    (event) => {
      const dialog = event.target;
      if (!(dialog instanceof HTMLDialogElement) || !openers.has(dialog)) return;
      const opener = openers.get(dialog);
      openers.delete(dialog);
      opener?.setAttribute('aria-expanded', 'false');
      if (opener?.isConnected) opener.focus({ preventScroll: true });
    },
    true
  );

  // A modal dialog hands Tab to the browser after its last element; keep it inside instead
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Tab') return;
    const dialog = event.target.closest?.('dialog[open]');
    if (!dialog?.matches(':modal')) return;
    const focusable = [
      ...dialog.querySelectorAll(
        'a[href], button:enabled, input:enabled:not([type="hidden"]), select:enabled, textarea:enabled, summary, [tabindex]:not([tabindex^="-"])'
      ),
    ].filter(
      (element) =>
        element.getClientRects().length &&
        !element.closest('[hidden], [inert]') &&
        !(element.type === 'radio' && !element.checked && dialog.querySelector(`input[type="radio"][name="${CSS.escape(element.name)}"]:checked`))
    );
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (!event.shiftKey && event.target === last) {
      event.preventDefault();
      first.focus();
    } else if (event.shiftKey && event.target === first) {
      event.preventDefault();
      last.focus();
    }
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-sheet-close], [data-modal-close]')) {
      event.target.closest('dialog')?.close();
    } else if (event.target instanceof HTMLDialogElement && event.target.matches('.sheet')) {
      event.target.close();
    }
  });

  document.addEventListener(
    'touchstart',
    (event) => {
      const handle = event.target.closest?.('[data-sheet-handle]');
      if (!handle) return;
      const dialog = handle.closest('dialog');
      const startY = event.touches[0].clientY;
      let offset = 0;
      const onMove = (moveEvent) => {
        offset = Math.max(0, moveEvent.touches[0].clientY - startY);
        dialog.style.transform = `translateY(${offset}px)`;
      };
      const onEnd = () => {
        dialog.style.transform = '';
        if (offset > 80) dialog.close();
        handle.removeEventListener('touchmove', onMove);
        handle.removeEventListener('touchend', onEnd);
      };
      handle.addEventListener('touchmove', onMove, { passive: true });
      handle.addEventListener('touchend', onEnd);
    },
    { passive: true }
  );

  window.loadSimilarProducts = async (group) => {
    if (!group || group.dataset.loaded) return;
    group.dataset.loaded = 'true';

    try {
      const response = await fetch(group.dataset.url);
      const { products } = await response.json();
      const exclude = group.dataset.exclude.split(',').filter(Boolean).map(Number);
      const price = Number(group.dataset.price);
      const list = group.querySelector('[data-similar-list]');
      const template = group.querySelector('[data-similar-item]');
      const format = new Intl.NumberFormat(document.documentElement.lang || 'de', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'EUR',
        minimumFractionDigits: 0,
      });

      products
        .filter((product) => product.available && !exclude.includes(product.id))
        .sort((a, b) => Math.abs(a.price - price) - Math.abs(b.price - price))
        .slice(0, 4)
        .forEach((product) => {
          const item = template.content.cloneNode(true);
          item.querySelector('a').href = product.url;
          item.querySelector('.card-alternative__heading').textContent = product.title;
          item.querySelector('.card-alternative__meta').textContent = group.dataset.meta.replace(
            '[price]',
            format.format(product.price / 100)
          );
          if (product.featured_image) {
            const image = document.createElement('img');
            image.src = `${product.featured_image}${product.featured_image.includes('?') ? '&' : '?'}width=240`;
            image.alt = '';
            image.loading = 'lazy';
            item.querySelector('.card-alternative__media').append(image);
          }
          list.append(item);
        });

      group.hidden = !list.children.length;
    } catch (error) {
      console.error(error);
    }
  };
}
